import loading from '../helpers/loading'
import collectionPerPage from '../helpers/collectionPerPage'

import actions from './actions'

export default {
  namespaced: true,
  state: {
    ...loading.state,
    ...collectionPerPage.state
  },
  mutations: {
    ...loading.mutations,
    ...collectionPerPage.mutations
  },
  getters: {
    ...loading.getters,
    ...collectionPerPage.getters,
    pending: (state, getters, rootState, rootGetters) => rootGetters['skiliko/messages/pending']
      .reduce((conversations, message) => {
        conversations[message.conversation] = conversations[message.conversation] || []
        conversations[message.conversation].push(message)
        return conversations
      }, {})
  },
  actions
}



// WEBPACK FOOTER //
// ./src/store/skiliko/conversations/index.js